import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function Subheading({ children }) {
  return (
    <Typography variant='h4' align='center' color='secondary.500' sx={{
      fontWeight: 'bold',
      mb: 2
    }}>
      {children}
    </Typography>
  );
}

Subheading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Subheading;
